import { render, staticRenderFns } from "./sbStepFile.vue?vue&type=template&id=256d191a&scoped=true"
import script from "./sbStepFile.vue?vue&type=script&lang=ts"
export * from "./sbStepFile.vue?vue&type=script&lang=ts"
import style0 from "./sbStepFile.vue?vue&type=style&index=0&id=256d191a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d191a",
  null
  
)

export default component.exports